<template>
    <div id="menu" :class="{'menu': true, 'fixed': fixed}">
        <div id="top"></div>
        <div v-show="fixed == false" class="social-menu hide-on-med-and-down white-text">
            <div class="container">
                Follow us: 
                <a :href="facebook" target="_blank"><font-awesome-icon :icon="fbIcon" /></a>
                <a :href="youtube" target="_blank"><font-awesome-icon :icon="ytIcon" /></a>
            </div>
        </div>
        <nav class="transparent">
            <div class="container nav-wrapper">
                <router-link class="brand-logo left" :to="{name: 'index', hash: '#home'}"><img src="/assets/images/logo/Logo-White.svg"></router-link>
                <a href="#" data-target="mobile-menu" class="sidenav-trigger right"><i class="material-icons">menu</i></a>
                <ul id="nav-desktop" class="right hide-on-med-and-down">
                    <li v-for="(item, index) in navItems" :key="index" :class="{'active': '#' + active == item.hash}">
                        <router-link :to="{name: item.routeName, hash: item.hash}">{{ item.name }}</router-link>
                    </li>
                </ul>
            </div>
        </nav>


        <ul class="sidenav" id="mobile-menu">
            <li><a href="javascript:;" :class="{'sidenav-close': true}">&#10005;</a></li>
            <li v-for="(item, index) in navItems" :key="index">
                <router-link :to="{name: item.routeName, hash: item.hash}" :class="{'sidenav-close': true, 'active': '#' + active == item.hash}">{{ item.name }}</router-link>
            </li>
            <li><a :href="facebook" target="_blank"><font-awesome-icon :icon="fbIcon" /></a></li>
        </ul>
    </div>
</template>

<script>
    import ENV from '../constants/Environment.js';
    import { faFacebookSquare, faYoutubeSquare } from '@fortawesome/free-brands-svg-icons';
    import M from 'materialize-css';

    export default {
        name: 'Menu',
        computed: {
            fbIcon () {
                return faFacebookSquare
            },
            ytIcon () {
                return faYoutubeSquare
            },   
        },
        mounted: function() { 
            var self = this;

            var elems = document.querySelectorAll('.sidenav');
            M.Sidenav.init(elems, {
                "edge": 'right'
            });
            
            const sectionElements = document.querySelectorAll('section');
            const sections = [...sectionElements].filter(function (e) {
                return e.tagName == 'SECTION';
            });
            
            window.onscroll = function() {
                var current_position = document.getElementById('top').getBoundingClientRect().top;

                //SETS ACTIVE MENU ITEMS
                sections.forEach(function(element) {
                    var top = element.getBoundingClientRect().bottom - element.getBoundingClientRect().height - 150;
                    var bottom = element.getBoundingClientRect().bottom;
                    if (current_position >= top && current_position <= bottom) {
                        self.active = element.id;
                    }
                });
                
                //SET HEADER TO FIXED WHEN SCROLL
                // var header_bottom_pos = document.getElementById('home').getBoundingClientRect().bottom;
                // var scroll_offset = -600;
                // if (current_position + scroll_offset < -header_bottom_pos) {
                //     self.fixed = true;
                // }
                // else {
                //     self.fixed = false;
                // }

                var header = document.getElementById("home");
                if (header) {
                    var sticky = header.offsetTop + 110;
                    if (window.pageYOffset > sticky) {
                        self.fixed = true;
                    } else {
                        self.fixed = false;
                    }
                }
            };
        },
        data: function() {
            return {
                facebook: ENV.FACEBOOK_LINK,
                youtube: ENV.YOUTUBE_LINK,
                fixed: false,
                active: "",
                navItems: [{
                    name: "Home",
                    routeName: "index",
                    hash: "#home"
                },{
                    name: "About Us",
                    routeName: "index",
                    hash: "#aboutus"
                },{
                    name: "Services",
                    routeName: "index",
                    hash: "#services"
                },{
                    name: "Beliefs",
                    routeName: "index",
                    hash: "#beliefs"
                },{
                    name: "Missions",
                    routeName: "index",
                    hash: "#missions"
                },{
                    name: "Prayer",
                    routeName: "index",
                    hash: "#prayer"
                },{
                    name: "Location",
                    routeName: "index",
                    hash: "#location"
                }]
            }
        },
        methods: {

        }
    }
</script>

<style scoped>
    .menu {
        /* padding-top: 15px; */
        background: #222;
    }
    nav .nav-wrapper {
        z-index: 1;
    }
    nav, nav .nav-wrapper i, nav a.sidenav-trigger, nav a.sidenav-trigger i {
        height: 72px;
        line-height: 72px;
    }
    nav ul a {
        font-size: 1.25rem;
        transition: all 0.5s ease;
    }

    nav ul a:hover {
        color: #fff;
    }

    .social-menu {
        background: #222;
        text-align: right; 
        position: relative; 
        z-index: 2;
        height: 30px;
        padding-top:2px;

    }
    
    .social-menu a:first-child {
        padding-left: 15px;
    }


    .social-menu a {
        color: #ffffff;
        padding: 0 5px 0 0;
        font-size: 1.5rem;
    }

    .social-menu a:hover {
        color: #5b7c8a;
    }

    .brand-logo {
        margin-top: 10px;
    }

    .brand-logo img {
        width: 100%;
        max-width: 90px;
    }

    nav ul li.active {
        background: rgba(91,124,138, .7);
        /* border-radius: 2px; */
    }
    .sidenav {
        text-align: center;
        width: 100%;
        background: rgba(9,12,13, .7);
        padding-top: 50px;
    }

    .sidenav li:first-child {
        margin-bottom: 1rem;
    }

    .sidenav li>a {
        color: #ffffff;
        font-size: 2.25rem;
        font-family: NewhouseDTCond-ExtBold;
        line-height: 60px;
        height: 60px;
    }

    .sidenav li>a.active {
        color: #5b7c8a;
    }

    .sidenav li>a:hover {
        color: #5b7c8a;
        background: none;
    }

    .sidenav li a.sidenav-close {
        font-size: 3rem;
        font-weight: bold;
    }

    .menu.fixed {
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 99;
    }

    .menu.fixed nav {
        background: rgba(9,12,13, .7) !important;
    }

    nav a.sidenav-trigger i {
        font-size: 2.5rem
    }
</style>

